var exports = {
  "uK": "GiftPlutoniumModal.module__option___YXpkY3",
  "fS": "GiftPlutoniumModal.module__optionName___YXpkY3",
  "$f": "GiftPlutoniumModal.module__optionPrice___YXpkY3",
  "f2": "GiftPlutoniumModal.module__saving___YXpkY3",
  "N4": "GiftPlutoniumModal.module__note___YXpkY3",
};

module.exports = exports;
